<template>
  <div class="product-card" @click="viewProduct">
    <div class="pic-wrap"><img :class="imageClass" :src="productImage"/></div>
    <div class="count-num">数量：{{ cardData.productData.soncount || 0 }}</div>
    <div class="product-name">{{ cardData.productData.productName || unKnowName }}</div>
    <div class="product-batch-name">{{ cardData.productData.ProductBatchCode }}</div>
  </div>
</template>
<script>
  import defaultImage from '@/assets/images/product-default-image.png';
  export default {
    props: {
      cardData: Object
    },
    data(){
      return {
        unKnowName: '未知产品',
        imageClass: ''
      };
    },
    computed: {
      productImage(){
        const {productData} = this.cardData;
        const img = productData.img;
        return img || defaultImage;
      }
    },
    methods: {
      viewProduct(){
        const code = this.cardData.productData.code;
        if (this.cardData.productData.productName) {
          this.$router.push({path: '/', query: {code, showresult: 1}});
        }
      },
      calcImageSize(){
        const img = new Image();
        img.onload = () => {
          const {width, height} = img;
          if (width > height) {
            this.imageClass = 'height-max';
          } else {
            this.imageClass = 'width-max';
          }
        };
        img.src = this.productImage;
      }
    },
    mounted(){
      this.calcImageSize();
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .pic-wrap {
    position: relative;
    width: 60%;
    margin: auto;
    font-size: 0;
    border-radius: 50%;
    padding-bottom: 60%;
    margin-top: 0.5rem;
    overflow: hidden;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      &.width-max {
        width: 100%;
      }
      &.height-max {
        height: 100%;
      }
    }
  }

  .count-num {
    margin-top: 0.417rem;
  }

  .count-num, .product-name, .product-batch-name {
    font-size: 13px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 0.175rem;
  }

  .product-batch-name {
    font-size: 10px;
    color: #dddddd;
  }
</style>



// WEBPACK FOOTER //
// product-card.vue?279cecbe